var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"l-ss-c-offer-image-search-similar",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.imageIcon)},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.onChange()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }